import React from 'react'
import { observer } from 'mobx-react-lite'

import { DropdownItemProps } from './DropdownButton'
import { UnmatchProductsButton } from './UnmatchProductsButton'
import { MatchWbToMoySkladButton } from './MatchWbToMoySkladButton'
import { MatchOzonToMoySkladButton } from './MatchOzonToMoySkladButton'
import { MatchYandexMarketToMoySkladButton } from './MatchYandexMarketToMoySkladButton'

import { useLogic } from '../hooks/storeHook'
import { useStoreAccountOptional } from '../hooks/routeHooks'

import { UnprocessedValueError } from '../common/tsUtils'
import { makeOzonAccountName, makeWbAccountName, makeYandexMarketAccountName } from '../common/accountUtils'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

export type MatchStoreProductsButtonsProps = {
  buttonProps: DropdownItemProps
}

export const MatchStoreProductsButtons =
  observer(
    ({buttonProps}: MatchStoreProductsButtonsProps) => {
      const account = useStoreAccountOptional()

      const logic = useLogic()

      if (!account) {
        console.error(`Bad account in MatchStoreProductsButtons at ${window.location.href}`)
        return null
      }

      const {integrationType} = account

      switch (integrationType) {
        case IntegrationType.Ozon:
          return <>
            <MatchOzonToMoySkladButton
              accountIdFrom={account.id}
              accountIdFromTitle={makeOzonAccountName(account)}
              {...buttonProps}/>

            <UnmatchProductsButton
              account={account}
              makeAccountName={makeOzonAccountName}
              onSubmit={logic.unmatchOzonProducts}
              {...buttonProps}/>
          </>

        case IntegrationType.Wildberries:
          return <>
            <MatchWbToMoySkladButton
              accountIdFrom={account.id}
              accountIdFromTitle={makeWbAccountName(account)}
              {...buttonProps}/>

            <UnmatchProductsButton
              account={account}
              makeAccountName={makeWbAccountName}
              onSubmit={logic.unmatchWbProducts}
              {...buttonProps}/>
          </>

        case IntegrationType.YandexMarket:
          return <>
            <MatchYandexMarketToMoySkladButton
              accountIdFrom={account.id}
              accountIdFromTitle={makeYandexMarketAccountName(account)}
              {...buttonProps}/>

            <UnmatchProductsButton
              account={account}
              makeAccountName={makeYandexMarketAccountName}
              onSubmit={logic.unmatchYandexMarketProducts}
              {...buttonProps}/>
          </>

        default:
          throw new UnprocessedValueError('StoreIntegrationType', integrationType)
      }
    })